import { useState, useEffect } from 'react';
import localforage from 'localforage';

const API_BASE_URL = process.env.REACT_APP_GRAPHQL_SERVER_BASE_URL || 'http://localhost';

/**
 * Detecta país/moneda/pasarela del usuario según su IP:
 *  - Colombia → Wompi / COP
 *  - Resto    → Stripe / USD (gatewayEnabled indica si Stripe ya está activo)
 *
 * @returns {{ gateway: 'wompi'|'stripe'|null, currency: 'COP'|'USD'|null, gatewayEnabled: boolean, loading: boolean }}
 */
function useIpGeolocation() {
  const [data, setData] = useState({ gateway: null, currency: null, gatewayEnabled: false, loading: true });

  useEffect(() => {
    let cancelled = false;

    const detect = async () => {
      try {
        const token = await localforage.getItem('otx_a');
        // Override de pruebas (solo sandbox): localStorage.setItem('otx_force_currency','USD')
        const force = window.localStorage.getItem('otx_force_currency');
        const qs = force ? `?force_currency=${encodeURIComponent(force)}` : '';
        const response = await fetch(`${API_BASE_URL}/api/payment/detect-currency${qs}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
          },
        });

        if (response.ok) {
          const result = await response.json();
          const detection = {
            gateway: result.gateway || 'wompi',
            currency: result.currency || 'USD',
            gatewayEnabled: Boolean(result.gateway_enabled),
          };
          if (!cancelled) setData({ ...detection, loading: false });
        } else {
          throw new Error('Detection failed');
        }
      } catch {
        const fallback = { gateway: 'wompi', currency: 'USD', gatewayEnabled: false };
        if (!cancelled) setData({ ...fallback, loading: false });
      }
    };

    detect();

    return () => {
      cancelled = true;
    };
  }, []);

  return data;
}

export default useIpGeolocation;
